import { APP_NAME } from '@/shared/config/app';
import { NAVIGATION_ITEMS } from '@/shared/config/navigation';
import type { ReactNode } from 'react';

export interface MobileSection {
  /** Label of the matching primary-nav item (e.g. Raw Footage); the app name when none matches. */
  context: ReactNode;
  /** Nested under a section → link back to its section root; null at the root or with no match. */
  backTo: string | null;
  /** Whether the path is exactly the matching primary-nav section root. */
  isSectionRoot: boolean;
}

/**
 * Resolves which primary-nav section a path belongs to (longest match), for the
 * mobile top-bar title and nested back target. Pure — pass in the current
 * pathname (the caller reads it from the router).
 */
export function resolveMobileSection(pathname: string): MobileSection {
  let bestTo: string | null = null;
  let bestLabel: ReactNode = APP_NAME;
  let bestLen = -1;

  for (const item of NAVIGATION_ITEMS) {
    const pattern = item.activePattern ?? item.to;
    const matches = pathname === pattern || pathname.startsWith(`${pattern}/`);
    if (matches && pattern.length > bestLen) {
      bestLen = pattern.length;
      bestTo = item.to;
      bestLabel = item.label;
    }
  }

  const atSectionRoot = bestTo != null && (pathname === bestTo || pathname === `${bestTo}/`);

  return {
    context: bestLabel,
    backTo: bestTo && !atSectionRoot ? bestTo : null,
    isSectionRoot: atSectionRoot,
  };
}
